import React from 'react';

import { getCroppedImageUrl } from '@weee-fe/module';

import Description from './description';
import Icon from './icon';
import SubTitle from './sub-title';
import Title from './title';

import type { FeatureHeaderProperties } from './index';
interface LayoutLeftProps {
  className?: string;
  properties: FeatureHeaderProperties;
}

const LayoutLeft: React.FC<LayoutLeftProps> = ({ properties }) => {
  const { mobile_media } = properties;

  if (mobile_media) {
    return (
      <div
        className="relative w-full bg-center bg-no-repeat bg-cover px-10 pt-[120px] pb-10 box-border"
        style={{
          backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.3) 100%), url(${getCroppedImageUrl(
            mobile_media,
            {
              renderWidth: 980
            }
          )})`
        }}
        data-testid="mod-featured-header-layout-left">
        <Icon properties={properties} wrapperClassName="absolute top-10 left-10" />
        <SubTitle properties={properties} className="text-[#ffffff]" />
        <Title properties={properties} className="py-3 text-[#ffffff]" />
        <Description properties={properties} className="text-[#ffffff]" />
      </div>
    );
  }

  return (
    <div className="w-full px-10 py-5 box-border">
      <Icon properties={properties} wrapperClassName="mb-3" />
      <SubTitle properties={properties} />
      <Title properties={properties} className="my-3" />
      <Description properties={properties} />
    </div>
  );
};

export default LayoutLeft;
